import React, { useEffect, useState } from 'react';
import BannerImg from '../../../Assets/images/Activation/activationBanner.webp';
import BannerIpadImg from '../../../Assets/images/Activation/activationBannerIPad.webp';
import phoneIcon from '../../../Assets/images/PostActivation/Help/phone_at.svg';
import ButtonNew from '../../../components/Button/Button';
import Footer from '../../../components/Footer/Footer';
import PostHeader from '../../../components/Header/PostHeader';
import SimpleHeader from '../../../components/Header/simpleHeader';
import { globalVal } from '../../../global/globalvalues';
import './help.scss';
import { Helmet } from 'react-helmet';
import { seoData } from '../../../global/seoData';
import { useSelector } from 'react-redux';
type initialProps = {
    history: any;
};
function Help(props: initialProps) {
    const [customerDetails, setCustomerDetails] = useState<any>(null);
    const configState = useSelector((state: any) => state.billing.config);

    useEffect(() => {
        window.scroll(0,0);
        let customerDetails: any = localStorage.getItem('customerDetail');
        customerDetails = JSON.parse(customerDetails);
        localStorage.removeItem('secondaryCustomerDetail');
        setCustomerDetails(customerDetails);
    }, []);

    return (
        <div className="helpMain">
            <Helmet>
                <title>{seoData.help.title}</title>
                <meta property="og:site_name" name="site_name" content={globalVal && globalVal.long_name} />
                <meta property="og:title" name="title" content={seoData.help.title} />
                <meta property="og:description" name="description" content={seoData.help.description} />
                <meta name="description" content={seoData.help.description} />
                <meta name="keywords" content={seoData.help.keywords} />
                <meta name="robots" content="noindex, nofollow" />
                <meta property="twitter:site_name" name="site_name" content={globalVal && globalVal.long_name} />
                <meta name="twitter:title" content={seoData.help.title} />
                <meta name="twitter:description" content={seoData.help.description} />
                <link rel="canonical" href={seoData.help.canonicalUrl} />
            </Helmet>
            {customerDetails &&
            (customerDetails.status == 1 ||
                customerDetails.status == 2 ||
                customerDetails.status == 3 ||
                customerDetails.status == 4 ||
                customerDetails.status == 5 ||
                customerDetails.status == 8 ||
                customerDetails.status == 9 ||
                customerDetails.status == 10) ? (
                <PostHeader 
                    history={props.history}
                    showServiceTab = {configState?.data?.configs?.SERVICE_TAB === 'ENABLE' ? true : false }
                // enableServiceInPrimarySus={configState?.data?.configs?.ENABLE_LINE_SERVICES_WHEN_PRIMARY_SUSPENEDED} 
                />
            ) : (
                <SimpleHeader history={props.history} isHelp={true} user={customerDetails} />
            )}

            <div className="bannerImg" style={{margin:0}}>
                <img src={BannerImg} alt="img" className="WebImg" />
                <img src={BannerIpadImg} alt="img" className="IpadImg" />
                <div className="contentCarousel">
                    <h1 style={{ display: 'none' }}>Support Center</h1>
                    <div className="Goodbye-mobile-store">Support</div>
                </div>
            </div>
            <div className="helpOuter">
                <div className="helpTitle">Support Center</div>
                <div className="helpContent">
                    Questions about Astound Mobile? Find answers on getting the most out of your services, international
                    rates, network coverage, bill & account information, and more!
                </div>
                <ButtonNew
                    className="supportCTA"
                    primary={true}
                    onClick={() => window.open(`${globalVal && globalVal.help_page}`, '_blank')}
                >
                    Support Center
                </ButtonNew>
            </div>

            <div className="helpOuterTwo">
                <div className="helpTitleTwo">Looking for more immediate support?</div>
                <div className="helpTitleThree">Speak with one of our experts</div>
                <a href={`tel:1.800.427.8686`}>
                    <img src={phoneIcon} className="phone_icon" alt='Call icon' />
                </a>
                <div className="callText">CALL 1.800.427.8686</div>
            </div>
            <Footer isFixed={true} />
        </div>
    );
}

export default Help;
